module.exports = __webpack_public_path__ + "static/img/icon-03.4b969d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/value/icon-03.png
// module id = G/KD
// module chunks = 1